import React from 'react';
import img26 from './1656436013898.jpg'
import img27 from './HTD WILD OPTICALS_Haridass T.png'
import img28 from './business card back.png'
import img29 from './business card front.jpg'
import img30 from './envelope.jpg'
import img31 from './letterpad.jpg'
import img32 from './Package.jpeg'
import img33 from './book full.jpg'
import img34 from './book.png'
import img35 from './mesh paniting.jpg'
import img36 from './brand.jpg'
import img37 from './yoga lifeblance.jpg'



export function Coral(){
    return(
        <div className='bg-dark'>
            <div className='container-fluid'>
                <div className='row  '>

        <img src={img26} className='col-lg-4 mt-3 imghover'/>
        <img src={img27} className='col-lg-8 mt-3 imghover'/>
        <img src={img28} className='col-lg-5 mt-3 imghover'/>
        <img src={img29} className='col-lg-5 mt-3 imghover'/>
        <img src={img30} className='col-lg-12 mt-3 imghover'/>
        <img src={img31} className='col-lg-6 mt-3 imghover'/>
        <img src={img32} className='col-lg-6 mt-3 imghover'/>
        <img src={img33} className='col-lg-6 mt-3 imghover'/>
        <img src={img34} className='col-lg-6 mt-3 imghover'/>
        <img src={img35} className='col-lg-6 mt-3 imghover'/>
        <img src={img36} className='col-lg-6 mt-3 imghover'/>
        <img src={img37} className='col-lg-6 mt-3 imghover'/>
    
        
        
       
        </div>
        </div>
</div>
    )
   
    }